import axiosService from "@/services/axiosService";
import router from "@/router";
const state = {};

const getters = {};

const mutations = {};

const actions = {
  async sendNotification({ commit, state }, payload) {
    try {
      const { data } = await axiosService.post(`/notifications`, {
        accountTypes: payload.accountTypes,
      });
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
